import { action, observable } from 'mobx'

export class BoxSummaryStore {
  @observable currentBoxSummary = null
  @observable currentTableIndex = -1
  @observable boxSumaryList = null

  @action setCurrentBoxSummary = (current) => {
    this.currentBoxSummary = current
  }

  @action setBoxSumaryList = (list) => {
    this.boxSumaryList = list
  }
}
